import React from "react";
import CSSModules from "lib/utils/css-modules";

import * as FormControl from "lib/components/FormControl";
import { PaymentProfileProductAttachmentDecorator } from "lib/decorators/index";
import st from "lib/utils/index";
import styles from "./PaymentProfileProductAttachmentFormSection.less";
import PaymentProfileLabel from "./PaymentProfileLabel";

@CSSModules(styles)
export default class PaymentProfileProductAttachmentFormSection extends React.PureComponent {
  handlePaymentProfileAttachmentPropChange(prop, value) {
    const { payment_profile, attachment, onChange } = this.props;
    const nextAttachment = new PaymentProfileProductAttachmentDecorator({
      ...(attachment ||
        PaymentProfileProductAttachmentDecorator.build({
          uuid: st.generateUuid(),
          payment_profile_id: payment_profile.id,
        })),
      [prop]: value,
    });
    onChange(nextAttachment);
  }

  render() {
    const { payment_profile, attachment, name, errors, onBlur, onEditClick, editable } = this.props;
    const isActive = attachment ? attachment.active : false;
    // const label = <PaymentProfileLabel pp={payment_profile} onEditClick={onEditClick} />
    const label = <PaymentProfileLabel pp={payment_profile} />;

    const attachmentDateLimitTypeOptions =
      isActive &&
      (parent.booking_type !== "no_booking"
        ? [
            ["no_date_limit", I18n.t("papp.components.PaymentProfileProductAttachmentFormSection.no_date_limit")],
            [
              "days_before_arrival_date_limit",
              I18n.t("papp.components.PaymentProfileProductAttachmentFormSection.days_before_arrival_date_limit"),
            ],
          ]
        : [["no_date_limit", I18n.t("papp.components.PaymentProfileProductAttachmentFormSection.no_date_limit")]]);

    return (
      <div styleName="profile">
        <div styleName="profile-row">
          <div styleName="profile-left">
            {!editable && label}
            {editable && (
              <FormControl.CheckboxFormGroup
                {...FormControl.addProps(`${name}.payment_profile_id`, { errors })}
                checked={isActive}
                onBlur={onBlur}
                onChange={this.handlePaymentProfileAttachmentPropChange.bind(this, "active")}
                label={label}
                toggle
              />
            )}
          </div>
          {isActive && attachmentDateLimitTypeOptions.length > 1 && (
            <div styleName="profile-right">
              <div>
                <div styleName="profile-select" className="fields inline">
                  <FormControl.SelectFormGroup
                    {...FormControl.addProps(`${name}.date_limit_type`, { errors })}
                    value={attachment.date_limit_type}
                    onBlur={onBlur}
                    onChange={this.handlePaymentProfileAttachmentPropChange.bind(this, "date_limit_type")}
                    label={I18n.t("papp.components.PaymentProfileProductAttachmentFormSection.active")}
                    options={attachmentDateLimitTypeOptions}
                    className="u-mediumWidth"
                  />
                </div>
                {attachment.date_limit_type === "days_before_arrival_date_limit" && (
                  <div styleName="profile-select-details" className="fields inline">
                    <label>
                      {I18n.t(
                        "papp.components.PaymentProfileProductAttachmentFormSection.days_before_arrival_date_limit_label"
                      )}
                    </label>

                    <FormControl.InputFormGroup
                      {...FormControl.addProps(`${name}.min_days_before_arrival`, { errors })}
                      value={attachment.min_days_before_arrival}
                      onBlur={onBlur}
                      onChange={this.handlePaymentProfileAttachmentPropChange.bind(this, "min_days_before_arrival")}
                      label={I18n.t("base.from")}
                      type="number"
                      min="0"
                      className="u-tinyWidth"
                      placeholder="0"
                    />

                    <FormControl.InputFormGroup
                      {...FormControl.addProps(`${name}.max_days_before_arrival`, { errors })}
                      value={attachment.max_days_before_arrival}
                      onBlur={onBlur}
                      onChange={this.handlePaymentProfileAttachmentPropChange.bind(this, "max_days_before_arrival")}
                      label={I18n.t("base.to")}
                      type="number"
                      min="0"
                      className="u-tinyWidth"
                      placeholder="-"
                    />

                    <label>{I18n.t("base.x_days", { count: "" })}</label>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/PaymentProfileProductAttachmentFormSection.jsx